export type PaymentStatusTone = 'success' | 'warning' | 'error' | 'info' | 'neutral'

function normalizeKey(status?: string | null): string {
  return (status || 'Unpaid')
    .trim()
    .toLowerCase()
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
}

/** Human label for a raw API / option-set payment status. */
export function formatPaymentStatusLabel(status?: string | null): string {
  const spaced = (status || 'Unpaid').trim().replace(/[_-]+/g, ' ').replace(/\s+/g, ' ')
  if (!spaced) return 'Unpaid'
  if (spaced === spaced.toLowerCase()) {
    return spaced.charAt(0).toUpperCase() + spaced.slice(1)
  }
  return spaced
}

/** Distinct tone so in-flight pay states are not the same red as unpaid. */
export function paymentStatusTone(status?: string | null): PaymentStatusTone {
  const key = normalizeKey(status)
  if (key === 'paid') return 'success'
  if (key === 'partial' || key === 'partially refunded') return 'warning'
  if (key === 'refunded') return 'neutral'
  if (
    key === 'awaiting payment' ||
    key === 'pending' ||
    key === 'proceed to card payment' ||
    key === 'proceed to additional card'
  ) {
    return 'warning'
  }
  if (key === 'pay via invoice') return 'info'
  if (key === 'cancelled' || key === 'canceled') return 'neutral'
  return 'error'
}
